import { Entities } from '@/entities/api/entities'
import ProductDetails from '@/entities/api/products/details'
import { ProductFormValues } from '@/entities/schemas/products'

const productDetailsConvert = (
	details: ProductFormValues['details'],
	type: Entities
): ProductDetails => {
	const partial: Partial<ProductDetails> = {}

	switch (type) {
		case Entities.SUPPLEMENTS:
			partial.general_details = {
				brand: details.general_details.brand ?? '',
				principal_supplement:
					details.general_details.principal_supplement ?? '',
				type: details.general_details.type ?? '',
			}
			partial.specifications = {
				is_gluten_free: details.specifications?.is_gluten_free ?? false,
				is_vegan: details.specifications?.is_vegan ?? false,
				have_lactose: details.specifications?.have_lactose ?? false,
			}
			partial.buy_format = {
				suplement_format: details.buy_format?.suplement_format ?? '',
				container_type: details.buy_format?.container_type ?? '',
			}
			partial.nutritional_information = {
				ingredients: details.nutritional_information?.ingredients ?? '',
				nutritional_portion_value:
					details.nutritional_information?.nutritional_portion_value ?? '',
				portion_weight: details.nutritional_information?.portion_weight ?? '',
			}
			break

		case Entities.CLOTHES:
			partial.general_details = {
				brand: details.general_details.brand ?? '',
				model: details.general_details.model ?? '',
				age: details.general_details.age ?? '',
				gender: details.general_details.gender ?? '',
				materials: details.general_details.materials ?? '',
			}
			break

		case Entities.ACCESSORIES:
			partial.general_details = {
				brand: details.general_details.brand ?? '',
				model: details.general_details.model ?? '',
				age: details.general_details.age ?? '',
				gender: details.general_details.gender ?? '',
				materials: details.general_details.materials ?? '',
			}
			partial.specifications = {
				is_non_slip: details.specifications?.is_non_slip ?? false,
				is_adjustable: details.specifications?.is_adjustable ?? false,
			}
			break

		case Entities.PLANS_PERSONALIZED:
			partial.general_details = {
				nutrition_plan: details.general_details.nutrition_plan ??  false,
				training_plan: details.general_details.training_plan ?? false,
				duration: details.general_details.duration ?? '',
				modality: details.general_details.modality ?? '',
				place: details.general_details.place ?? '',
			}
			break

		default:
			partial.general_details = {
				brand: '',
				principal_supplement: '',
				type: '',
			}
			break
	}

	return partial as ProductDetails
}

export default productDetailsConvert
